import config from "./config";
import Cookies from "js-cookie";
import { CreateKeyPartyPayloadDto } from "./dtos/create-key-party.dto";
import { PartialInvestorDto } from "./dtos/investor.dto";
import { ResponseError } from "./types/responseError";
import { UpdateKeyPartyPayloadDto } from "./dtos/update-key-party.dto";
import { KeyParty } from "./dtos/get-key-party.dto";

export async function createKeyParty(
  keyPartyData: CreateKeyPartyPayloadDto,
): Promise<KeyParty> {
  const response = await fetch(
    `${config.SID_GW_BASE_URL}/v1/profile/key-parties`,
    {
      credentials: "include",
      headers: {
        Authorization: Cookies.get("auth-token") ?? "",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(keyPartyData),
    },
  );
  if (!response.ok) {
    console.error(await response.text());
    throw new ResponseError("Error creating key party", response);
  }

  return response.json() as Promise<KeyParty>;
}

export const updateInvestor = async (
  partialInvestorDto: PartialInvestorDto,
) => {
  const response = await fetch(`${config.SID_GW_BASE_URL}/v1/investor`, {
    credentials: "include",
    headers: {
      Authorization: Cookies.get("auth-token") ?? "",
      "Content-Type": "application/json",
    },
    method: "PATCH",
    body: JSON.stringify(partialInvestorDto),
  });
  if (!response.ok) {
    console.error(await response.text());
    throw new ResponseError("Error updating investor", response);
  }
};

export const updateKeyParty = async (
  keyPartyId: string,
  partialKeyPartyDto: UpdateKeyPartyPayloadDto,
): Promise<KeyParty> => {
  const response = await fetch(
    `${config.SID_GW_BASE_URL}/v1/profile/key-parties/${keyPartyId}`,
    {
      credentials: "include",
      headers: {
        Authorization: Cookies.get("auth-token") ?? "",
        "Content-Type": "application/json",
      },
      method: "PATCH",
      body: JSON.stringify(partialKeyPartyDto),
    },
  );
  if (!response.ok) {
    console.error(await response.text());
    throw new ResponseError("Error updating key party", response);
  }
  return response.json() as Promise<KeyParty>;
};

export const deleteKeyParty = async (keyPartyId: string) => {
  const response = await fetch(
    `${config.SID_GW_BASE_URL}/v1/profile/key-parties/${keyPartyId}`,
    {
      credentials: "include",
      headers: {
        Authorization: Cookies.get("auth-token") ?? "",
      },
      method: "DELETE",
    },
  );
  if (!response.ok) {
    console.error(await response.text());
    throw new ResponseError("Error deleting key party", response);
  }
};
